<template>
  <div id="resultList">
    <div v-loading="loading" element-loading-text="拼命加载中" class="list_container">
      <p class="empty" v-if="searchList.length <= 0">很抱歉，没有找到与“{{ searchKey }}”相关内容</p>
      <ul class="knowledge_content" v-else>
        <!-- 文档 -->
        <li v-for="result in searchList" :key="result.id" :class="
        result.RSCFILETYPE === '1' || result.RSCFILETYPE === '4'
        ? 'audio'
        : result.RSCFILETYPE === '2'
        ? 'video'
        : result.RSCFILETYPE === '5'
        ? 'knowledge'
        : 'information'">
          <router-link v-if="result.RSCFILETYPE === '1' || result.RSCFILETYPE === '4'" tag="a" target="_blank"
                       :to="{name: 'ResourceDetail',query:{rscId:result.RSCID}}">
            <h2 v-html="result.TITLE">
              <!-- {{ result.TITLE }} -->
            </h2>
            <div class="audio_product">
              <img :src="result.RSCFILETYPE === '1' ? wordImg : audioImg">
              <span v-html="result.RSCDESC">{{ result.RSCDESC }}</span>
            </div>
            <div class="audio_tab">
              <ul>
                <li v-for="tags in result.BIAOQIANNAMES" :key="tags.id" v-show="tags.length">{{ tags }}</li>
              </ul>
            </div>
            <div class="small_icon">
              <ul>
                <li class="downNum"><span>{{ result.DOWNNUM }}</span></li>
                <li class="favorite"><span>{{ result.FAVNUM }}</span></li>
                <li class="time"><span>{{ result.UPLOADDATE }}</span></li>
                <li class="people"><span>{{ result.REALNAME }}</span></li>
              </ul>
            </div>
          </router-link>
          <router-link v-if="result.RSCFILETYPE === '2'" tag="a" :to="{name: 'ResourceDetail',query:{rscId:result.RSCID}}"
                       target="_blank">
            <h2 v-html="result.TITLE">
              {{ result.TITLE }}
            </h2>
            <div class="product">
              <img :src="result.RSCIMAGE ? result.RSCIMAGE : defaultSrc" class="coverImage"/>
              <span v-html="result.RSCDESC">{{ result.RSCDESC }}</span>
            </div>
            <div class="audio_tab">
              <ul>
                <li v-for="tags in result. BIAOQIANNAMES" :key="tags.id" v-show="tags.length">{{ tags }}</li>
              </ul>
            </div>
            <div class="small_icon">
              <ul>
                <li class="downNum"><span>{{ result.DOWNNUM }}</span></li>
                <li class="favorite"><span>{{ result.FAVNUM }}</span></li>
                <li class="time"><span>{{ result.UPLOADDATE }}</span></li>
                <li class="people"><span>{{ result.REALNAME }}</span></li>
              </ul>
            </div>
          </router-link>
          <router-link v-if="result.RSCFILETYPE === '5'" tag="a" :to="{name: 'Knowledge',query:{rscId:result.GROUPID}}"
                       target="_blank">
            <h2 v-html="result.GROUPNAME">
              {{ result.GROUPNAME }}
            </h2>
            <div class="product">
              <a class="fileImg">
                <i class="tip">知识单</i>
                <img :src="result.GROUPIMAGE ? result.GROUPIMAGE : defaultSrc" class="coverImage"/>
                <span class="contain">包含<i>{{ result.VIDEONUM }}</i>个视频</span>
              </a>
            </div>
            <div class="small_icon">
              <ul>
                <li class="downNum"><span>{{ result.PLAYNUM }}</span></li>
                <li class="favorite"><span>{{ result.GFAVNUM }}</span></li>
                <li class="time"><span>{{ result.GCREATETIME }}</span></li>
                <li class="people"><span>{{ result.OWNERUSERNAME }}</span></li>
              </ul>
            </div>
          </router-link>
          <router-link v-if="result.RSCFILETYPE === '6'" tag="a" :to="result.NEWSADR" target="_blank">
            <h2 v-html="result.NEWSTITLE">
              {{ result.NEWSTITLE }}
            </h2>
            <p v-html="result.DETAIL">{{ result.DETAIL }}</p>
            <div class="info_icon">
              <ul>
                <li>
                  <i class="el-icon-time"></i><span>{{ result.NCREATETIME }}</span>
                </li>
                <li>
                  <span>信息来源：{{ result.SOURCENAME }}</span>
                </li>
              </ul>
            </div>
          </router-link>
        </li>
      </ul>
      <!-- 分页 -->
      <div class="pages">
        <el-pagination
            :current-page="curIndex"
            layout="prev, pager, next"
            :total="pageTotal"
            background
            :page-size="pageSize"
            prev-text="上一页"
            next-text="下一页"
            @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <div class="hotspot_container">
      <div class="bottom">
        <h2><span>搜索热点</span></h2>
        <ul class="latestNewsList">
          <li @click="jumpToSearch(item.wordName)" v-for="(item,index) in hotList" :key="index">
            <i ref="hotList" :class="getClass(index)">{{ index + 1 }}</i>
            <a>{{ item.wordName }}</a>
            <i :class="hot(index)"></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {searchKey, hotKey} from '@/api/search';

export default {
  name: 'Search',
  layout: 'search',
  data() {
    return {
      count: 10,
      searchKey: '',
      searchList: [],
      hotList: [],
      curIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      rscFileType: null,
      loading: true,
      defaultSrc:  require('@/assets/images/common/default.png'),
      wordImg: require('@/assets/images/resource/word.png'),
      audioImg: require('@/assets/images/resource/video.png')
    };
  },
  async mounted() {
    this.searchKey = this.$route.params.key;
    await this.getResourceList();
    await this.getHotKey();
  },
  methods: {
    async getResourceList() {
      const params = {
        str: this.searchKey,
        page: this.curIndex
      };
      await searchKey(params).then(data => {
        if (data.success) {
          this.loading = false;
          const {result} = data;
          const dataTotal = result ? result.objectList : [];
          this.pageTotal = data.result.totalResultNumber;
          if (dataTotal.length) {
            dataTotal.map((item) => {

              if (!item.BIAOQIANNAMES)
                return item
              const tag =  item.BIAOQIANNAMES.length > 4 ? item.BIAOQIANNAMES.slice(0, 4) : item.BIAOQIANNAMES;
              for (let i = 0; i < tag.length; i++) {
                if (tag[i].length > 10) {
                  const newTag = tag[i].substr(0, 9) + '...';
                  tag[i] = newTag;
                }
              }
              item.BIAOQIANNAMES = tag;
              return item;
            })
          }
          this.searchList = dataTotal;
        } else {
          this.$message({
            type: 'error',
            message: data.errorMsg
          });
        }
      });
    },
    async getHotKey() {
      await hotKey().then(data => {
        if (data.success) {
          this.loading = false;
          const {result} = data;
          this.hotList = result.hotWords;
        } else {
          this.$message({
            type: 'error',
            message: data.errorMsg
          });
        }
      });
    },
    handleCurrentChange(size) {
      this.curIndex = size;
      this.getResourceList();
    },
    getClass(val) {
      let className = '';
      if (val === 0 || val === 1 || val === 2) {
        className = 'bef';
      } else {
        className = 'order';
      }
      return className;
    },
    hot(val) {
      let className = '';
      if (val === 0 || val === 1 || val === 2) {
        className = 'hot';
      }
      return className;
    },
    jumpToSearch(val) {
      let path = this.$route.path.slice(0, 2);
      let searchKey = val;
      searchKey = val;
      let routeData = this.$router.resolve({
        path: `/s/${searchKey}`
      });
      if (path === '/s') {
        window.open(routeData.location.path, '_self');
      } else {
        window.open(routeData.location.path, '_blank');
      }
    }
  }
};
</script>
